/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation FallbackRouteUpdateMutation($routeId: ID!,$customerAccountId: ID!, $type: CUSTOMER_TYPE, $displayName: String) {
  FallbackRouteUpdate(routeId: $routeId, customerAccountId: $customerAccountId, type: $type, displayName: $displayName) {
    message
    status
  }
}
`
